import React, { useContext, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import ModuleContext from '../../../CMFW/context/ModuleContext';
import { useForceRender } from '../../../hooks/useForceRender';
import Label from '../../../CMFW/input/Label';
import CATModel from '../../../models/CATModel';
import CircularProgress from '@material-ui/core/CircularProgress';
import GlossaryModel from '../../../models/GlossaryModel';

export type IProps = {};

const CATContextGlossary: React.FC<IProps> = () => {
  const forceRender = useForceRender();
  const module = useContext(ModuleContext) as CATModel;
  const glossaryModel = useMemo(() => new GlossaryModel({ render: forceRender, courseId: module.courseId }), [
    forceRender,
    module.courseId,
  ]);

  const active = module.getActive();

  useEffect(() => {
    if (active) {
      glossaryModel.loadItemEdit(active.contextItemId);
    }
  }, [glossaryModel, active]);

  if (active === null) {
    return null;
  } else if (glossaryModel.loadingItem) {
    return (
      <Wrapper>
        <CircularProgress size={10} />
      </Wrapper>
    );
  } else {
    return (
      <ModuleContext.Provider value={glossaryModel}>
        <Wrapper>
          <Label keyName={'title'} />
        </Wrapper>
      </ModuleContext.Provider>
    );
  }
};

export default CATContextGlossary;

const Wrapper = styled.div`
  margin: 4px;
  font-size: 14px !important;
  white-space: pre-wrap;
`;
